const $b03a4525a2a65a69$var$expiration = new Date(2024, 2, 2, 0, 48);
const $b03a4525a2a65a69$var$secondsNext2 = document.querySelector("[data-time__next--sec2]");
const $b03a4525a2a65a69$var$secondsNext1 = document.querySelector("[data-time__next--sec1]");
const $b03a4525a2a65a69$var$secondsCurrent2 = document.querySelector("[data-time__current--sec2]");
const $b03a4525a2a65a69$var$secondsCurrent1 = document.querySelector("[data-time__current--sec1]");
const $b03a4525a2a65a69$var$minutesNext2 = document.querySelector("[data-time__next--min2]");
const $b03a4525a2a65a69$var$minutesNext1 = document.querySelector("[data-time__next--min1]");
const $b03a4525a2a65a69$var$minutesCurrent2 = document.querySelector("[data-time__current--min2]");
const $b03a4525a2a65a69$var$minutesCurrent1 = document.querySelector("[data-time__current--min1]");
const $b03a4525a2a65a69$var$hoursNext2 = document.querySelector("[data-time__next--hour2]");
const $b03a4525a2a65a69$var$hoursNext1 = document.querySelector("[data-time__next--hour1]");
const $b03a4525a2a65a69$var$hoursCurrent2 = document.querySelector("[data-time__current--hour2]");
const $b03a4525a2a65a69$var$hoursCurrent1 = document.querySelector("[data-time__current--hour1]");
const $b03a4525a2a65a69$var$daysNext2 = document.querySelector("[data-time__next--day2]");
const $b03a4525a2a65a69$var$daysNext1 = document.querySelector("[data-time__next--day1]");
const $b03a4525a2a65a69$var$daysCurrent2 = document.querySelector("[data-time__current--day2]");
const $b03a4525a2a65a69$var$daysCurrent1 = document.querySelector("[data-time__current--day1]");
let $b03a4525a2a65a69$var$intervalID;
let $b03a4525a2a65a69$var$days;
let $b03a4525a2a65a69$var$hours;
let $b03a4525a2a65a69$var$minutes;
let $b03a4525a2a65a69$var$seconds;
function $b03a4525a2a65a69$export$2e2bcd8739ae039() {
    // for the first time
    $b03a4525a2a65a69$var$setDistance();
    $b03a4525a2a65a69$var$firstRenderCounter();
    $b03a4525a2a65a69$var$intervalID = setInterval($b03a4525a2a65a69$var$countDown, 1000);
}
function $b03a4525a2a65a69$var$countDown() {
    const timeBetween = $b03a4525a2a65a69$var$setDistance();
    $b03a4525a2a65a69$var$renderCounter();
    if (timeBetween <= 0) clearInterval($b03a4525a2a65a69$var$intervalID);
}
function $b03a4525a2a65a69$var$setDistance() {
    const timeBetween = ($b03a4525a2a65a69$var$expiration - new Date()) / 1000;
    if (timeBetween <= 0) {
        $b03a4525a2a65a69$var$days = 0;
        $b03a4525a2a65a69$var$hours = 0;
        $b03a4525a2a65a69$var$minutes = 0;
        $b03a4525a2a65a69$var$seconds = 0;
        return timeBetween;
    }
    $b03a4525a2a65a69$var$days = Math.floor(timeBetween / 86400);
    $b03a4525a2a65a69$var$hours = Math.floor(timeBetween / 3600) % 24;
    $b03a4525a2a65a69$var$minutes = Math.floor(timeBetween / 60) % 60;
    $b03a4525a2a65a69$var$seconds = Math.floor(timeBetween % 60);
}
function $b03a4525a2a65a69$var$firstRenderCounter() {
    $b03a4525a2a65a69$var$renderFirst($b03a4525a2a65a69$var$secondsCurrent1, $b03a4525a2a65a69$var$secondsCurrent2, $b03a4525a2a65a69$var$seconds);
    $b03a4525a2a65a69$var$renderFirst($b03a4525a2a65a69$var$minutesCurrent1, $b03a4525a2a65a69$var$minutesCurrent2, $b03a4525a2a65a69$var$minutes);
    $b03a4525a2a65a69$var$renderFirst($b03a4525a2a65a69$var$hoursCurrent1, $b03a4525a2a65a69$var$hoursCurrent2, $b03a4525a2a65a69$var$hours);
    $b03a4525a2a65a69$var$renderFirst($b03a4525a2a65a69$var$daysCurrent1, $b03a4525a2a65a69$var$daysCurrent2, $b03a4525a2a65a69$var$days);
}
function $b03a4525a2a65a69$var$renderFirst(current1, current2, time) {
    current2.textContent = $b03a4525a2a65a69$var$zeroForOneDigit(time).slice(-1);
    current1.textContent = $b03a4525a2a65a69$var$zeroForOneDigit(time).slice(0, 1);
}
function $b03a4525a2a65a69$var$renderCounter() {
    $b03a4525a2a65a69$var$render($b03a4525a2a65a69$var$secondsCurrent1, $b03a4525a2a65a69$var$secondsCurrent2, $b03a4525a2a65a69$var$secondsNext1, $b03a4525a2a65a69$var$secondsNext2, $b03a4525a2a65a69$var$seconds);
    $b03a4525a2a65a69$var$render($b03a4525a2a65a69$var$minutesCurrent1, $b03a4525a2a65a69$var$minutesCurrent2, $b03a4525a2a65a69$var$minutesNext1, $b03a4525a2a65a69$var$minutesNext2, $b03a4525a2a65a69$var$minutes);
    $b03a4525a2a65a69$var$render($b03a4525a2a65a69$var$hoursCurrent1, $b03a4525a2a65a69$var$hoursCurrent2, $b03a4525a2a65a69$var$hoursNext1, $b03a4525a2a65a69$var$hoursNext2, $b03a4525a2a65a69$var$hours);
    $b03a4525a2a65a69$var$render($b03a4525a2a65a69$var$daysCurrent1, $b03a4525a2a65a69$var$daysCurrent2, $b03a4525a2a65a69$var$daysNext1, $b03a4525a2a65a69$var$daysNext2, $b03a4525a2a65a69$var$days);
}
function $b03a4525a2a65a69$var$render(current1, current2, next1, next2, time) {
    const nextTime2 = $b03a4525a2a65a69$var$zeroForOneDigit(time).slice(-1);
    const nextTime1 = $b03a4525a2a65a69$var$zeroForOneDigit(time).slice(0, 1);
    next2.textContent = nextTime2;
    if (next2.textContent !== current2.textContent) {
        current2.classList.add("time__current--anim");
        next2.classList.add("time__next--anim");
        next2.addEventListener("transitionend", ()=>{
            current2.textContent = nextTime2;
            current2.classList.remove("time__current--anim");
            next2.classList.remove("time__next--anim");
        });
    }
    next1.textContent = nextTime1;
    if (next1.textContent !== current1.textContent) {
        current1.classList.add("time__current--anim");
        next1.classList.add("time__next--anim");
        next1.addEventListener("transitionend", ()=>{
            current1.textContent = nextTime1;
            current1.classList.remove("time__current--anim");
            next1.classList.remove("time__next--anim");
        });
    }
}
function $b03a4525a2a65a69$var$zeroForOneDigit(number) {
    return ("0" + number).slice(-2);
}


const $2e6188c09db36a6a$var$radios = document.querySelectorAll(".configs__app-radio");
document.addEventListener("click", (e)=>{
    if (e.target.matches(".configs__app-icon")) return;
    $2e6188c09db36a6a$var$radios.forEach((r)=>{
        r.checked = false;
    });
});


const $63eb283d27decb4d$var$loading = document.querySelector(".loading-page");
const $63eb283d27decb4d$var$HASHED_PASS = "912df38fe384db9fe00ce18570a569561a76a48acfaaffa01a859df4a9bcb66a";
if (localStorage.getItem("password") === $63eb283d27decb4d$var$HASHED_PASS) (0, $b03a4525a2a65a69$export$2e2bcd8739ae039)();
else $63eb283d27decb4d$var$setupLogin();
addEventListener("load", ()=>{
    setTimeout(()=>$63eb283d27decb4d$var$loading.classList.add("loading-page--hide"), 4000);
});
function $63eb283d27decb4d$var$setupLogin() {
    location.href = "./login";
}


//# sourceMappingURL=index.06102f91.js.map
